import { useEffect } from 'react';
import { usePredictManagementContext } from '../../../../predict-management/context/predict-management-context';

/**
 * Will show a popup for the given error message if it is truthy
 */
export const useRequestErrorMessages = (error: unknown) => {
  const { addErrorMessage } = usePredictManagementContext();

  useEffect(() => {
    if (error) {
      addErrorMessage?.(error as Error);
    }
  }, [addErrorMessage, error]);
};
